import React from 'react';
import GraphQLClientProvider from '../Provider';
export default function withGraphQLClientProvider(Component) {
    const WithGraphQLClientProvider = props => {
        return (React.createElement(GraphQLClientProvider, null,
            React.createElement(Component, { ...props })));
    };
    return WithGraphQLClientProvider;
}
